// Single source of truth for the web-only Tools — consumed by the tools sub-nav
// (src/proxy-suite/components/layout/ToolsSubNav.tsx) so the list, icons, routes and copy
// never drift between the pages that show them.

import { Fingerprint, Monitor, Search, Waypoints, type LucideIcon } from "@suite/components/icons";

export interface ToolEntry {
  icon: LucideIcon;
  /** Short label used in the sidebar and as the card title. */
  label: string;
  href: string;
  /** One-line description shown on the home archive cards. */
  description: string;
}

export const TOOLS: ToolEntry[] = [
  {
    icon: Fingerprint,
    label: "Browser Fingerprint",
    href: "/tools/fingerprint",
    description:
      "Inspect the repeatable browser signals sites can combine into a cookie-free snapshot.",
  },
  {
    icon: Waypoints,
    label: "WebRTC Leak Test",
    href: "/tools/webrtc-leak",
    description:
      "See whether WebRTC exposes your real IP address while you sit behind a proxy or VPN.",
  },
  {
    icon: Monitor,
    label: "User Agent Checker",
    href: "/tools/user-agent",
    description:
      "Parse a user-agent string — browser, engine, OS, device and the signals your browser exposes.",
  },
  {
    icon: Search,
    label: "IP Checker",
    href: "/tools/ip-checker",
    description:
      "See your public IP and what it reveals — city, region, country, ISP/organisation and ASN.",
  },
];
